<template>
    <v-row>
      <v-dialog v-model="showDialog" scrollable max-width="750px">
        <v-skeleton-loader
        v-if="loading"
          type="article, actions"
        ></v-skeleton-loader>
        <v-card v-if="!loading">
          <v-card-title>
            <v-panel>
               <span style="font-size: 20px;">
                  Registro de auditoría
               </span>
            </v-panel>
          </v-card-title>
          <v-card-text>
            <v-container>
               <v-form ref="form">
                  <v-row>
                        <v-col cols="12">                
                           <v-textarea @wheel="onWheel"
                              v-model="data.actionPayload"
                              :label="'Datos actualizados'"
                              autocomplete="none" auto-grow counter
                           />
                        </v-col>                       
                  </v-row>
               </v-form>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="showDialog=false" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.cancel').toUpperCase() }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  
    </v-row>	
  </template>
  
<script>
import BaseModule from '../../common/BaseModule.js'
import api from '../../../api/worktime'

export default {
   name: 'AuditLogDialog',
   mixins: [BaseModule],
   components: {
      
   },
   data() {
      return {
         showDialog: false,
         loading: true,
         data: {}
      }
   },
   methods: {
      onWheel(event) {
            event.stopPropagation()
        },
      // eslint-disable-next-line no-unused-vars
      open: function (action, payload) {

         this.showDialog = true;

         if (this.$refs.form) {
            this.$refs.form.resetValidation();
         }

         if (!payload) { 
            this.loading = false; 
            return;
         }

         this.loading = true;
         api.getAuditLog(payload, res => {
            this.data = res;
            if (this.data.actionPayload) { 
               this.data.actionPayload = JSON.stringify(JSON.parse(this.data.actionPayload),null,4);
            }
            this.loading = false;
         }, error => {
            this.$emit('show-alert',{ text: error, color: 'error', timeout: 3000 });
            this.loading = false;
         })


      }
   },
}
</script>